if (!customElements.get('image-zoom-modal')) {
  class ZoomModal extends HTMLElement {
    constructor() {
      super();
      this.selector = this.dataset.imageWrapperSelector;
    }

    connectedCallback() {
      if (this.closest('main')) document.body.insertBefore(this, document.body.firstChild);

      window.addEventListener('click', (e) => {
        const clickedElement = e.target.closest(this.selector) || e.target.closest('[data-zoom-action]');
        if(!clickedElement) return;

        const {
          zoomAction: action = 'open',
        } = clickedElement.dataset;

        switch (action) {
          case 'open':
            this.triggerMedia = e.target.closest('img, video');
            const allMedia = [...document.querySelector(this.selector).querySelectorAll('img, video')];
            this.mediaElements = allMedia.filter(media => {
              return !(media.tagName === 'IMG' && media.closest('video'));
            });
            this.open();
          break;
          case 'close':
            this.close();
          break;
          default: break;
        }
      });
    }

    close() {
      const fadeOut = function() {
        this.style.position = null;
        this.style.display = null;
        this.removeEventListener('transitionend', fadeOut);
      }

      this.addEventListener('transitionend', fadeOut, false);
      document.body.style.overflow = null;
      this.innerHTML = '';
      this.style.opacity = null;
    }

    open() {
      const startingIndex = this.mediaElements.findIndex(x => x === this.triggerMedia);
      this.innerHTML = `
      <div class="relative w-full">
        <button data-zoom-action="close" type="button" aria-label="close modal" class="absolute bg-primaryLight block top-0 right-0 p-7.5 flex items-center transition duration-200 hover:text-accent1 z-10 animation-spin">
          <div class="w-3 h-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 12 12">
              <path d="M10.795 0 6 4.795 1.2 0 0 1.2 4.795 6 0 10.795 1.2 12 6 7.205 10.795 12 12 10.795 7.205 6 12 1.2z"/>
            </svg>
          </div>
        </button>
        <swiper-image-gallery class="flex">
          <div class="w-1/4 p-10 h-screen overflow-hidden hidden md:block">
            <div class="h-4/5">
              <swiper-container 
                initial-slide="${startingIndex >= 0 ? startingIndex : 0}"
                data-thumbs
                slides-per-group="1"
                slides-per-view="auto"
                space-between="6"
                direction="vertical"
                class="zoom-modal-thumbs flex flex-col flex-wrap items-center justify-start gap-1.5 w-[max-content!important] text-transparent"
              >
                ${this.mediaElements.map((media) => `
                  <swiper-slide class="[&.swiper-slide-thumb-active]:border-primaryDark border border-current swiper-slide w-[72px!important] h-[78px!important] bg-image-bg cursor-pointer">
                    ${media.tagName === 'IMG' ? `
                      <img class="transition duration-200 block w-full h-full object-center object-cover" loading="lazy" height="${media.height}" width="${media.width}" alt="${media.alt}" src="${media.src}" />
                    ` : `
                      ${media.poster ? `
                        <img class="transition duration-200 block w-full h-full object-center object-cover" src="${media.poster}" />
                      ` : `
                        <video class="transition duration-200 block w-full h-full object-center object-cover" muted playsinline>
                          <source src="${media.querySelector('source')?.src || media.src}" type="${media.querySelector('source')?.type || 'video/mp4'}">
                        </video>
                      `}
                    `}
                  </swiper-slide>
                `).join('')}
              </swiper-container>
            </div>
          </div>
          <div class="w-full md:w-1/2 h-screen flex justify-center items-center">
            <div class="h-screen flex items-center bg-image-bg aspect-[3/4] overflow-hidden">
              <swiper-container
                initial-slide="${startingIndex >= 0 ? startingIndex : 0}"
                data-gallery
                pagination='{"el": ".swiper-pagination"}'
                pagination-type="fraction"
                zoom="true"
                thumbs-swiper=".zoom-modal-thumbs"
                class="cursor-zoom-in w-full"
                navigation-next-el="#next-zoom-modal"
                navigation-prev-el="#prev-zoom-modal"
              >
                ${this.mediaElements.map((media) => `
                  <swiper-slide class="">
                    <div data-zoom-container class="swiper-zoom-container">
                      ${media.tagName === 'IMG' ? `
                        <img class="block w-full h-full object-center object-contain" loading="lazy" height="2400" width="2400" alt="${media.alt}" src="${media.src.replace('width=1200', 'width=2400')}" />
                      ` : `
                        <video class="block w-full h-full object-center object-contain" autoplay muted ${media.poster ? `poster="${media.poster}"` : ''}>
                          <source src="${media.querySelector('source')?.src || media.src}" type="${media.querySelector('source')?.type || 'video/mp4'}">
                        </video>
                      `}
                    </div>
                  </swiper-slide>
                `).join('')}
              </swiper-container>
            </div>
          </div>

          ${this.mediaElements.length > 1 ? `
            <div class="flex items-center w-max gap-8 left-1/2 transform -translate-x-1/2 absolute bottom-0 bg-primaryLight z-20 px-5 py-8">
              <button id="prev-zoom-modal" class="disabled:opacity-20 hover:enabled:text-accent1" aria-label="previous slide" data-prev>
                <span class="block w-4 h-3 transform rotate-180">
                  <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14">
                    <defs>
                      <clipPath id="dpuo5a2tba">
                      <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                      </clipPath>
                    </defs>
                    <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                  </svg>
                </span>
              </button>
              <div class="swiper-pagination"></div>
              <button id="next-zoom-modal" class="disabled:opacity-20 hover:enabled:text-accent1" aria-label="next slide" data-next>
                <span class="block w-4 h-3">
                  <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14">
                    <defs>
                      <clipPath id="dpuo5a2tba">
                        <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                      </clipPath>
                    </defs>
                    <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                  </svg>
                </span>
              </button>
            </div>
          ` : ''}
        </swiper-image-gallery>
      </div>
      `;
      this.style.display = 'block';
      this.style.position = 'fixed';
      document.body.style.overflow = 'hidden';
      setTimeout(() => { this.style.opacity = 1 }, 10);
    }
  }

  customElements.define('image-zoom-modal', ZoomModal);
}